import React, { FC } from 'react';
import { useSelector } from 'react-redux';

import { MusteringPanel } from './mustering-panel';
import { OccupancyHeader } from './occupancies-header';
import { OccupanciesByZone } from './occupancies-by-zone';
import { OccupanciesByDevice } from './occupancies-by-device';
import { zoneGuardsMusteringSelector, zoneGuardsOccupancySelector } from 'core/redux/selectors/zoneGuardsOccupancy';

import styles from './styles.module.css';

interface IZoneGuardProps {
  isLoading: boolean;
  isEmergencyMode: boolean;
  isSortedByZone: boolean;
  processorId: number;
  toggleSortByZone: (value: boolean) => void;
}

export const ZoneGuardOccupancy: FC<IZoneGuardProps> = (props) => {
  const { isLoading, isEmergencyMode, isSortedByZone, processorId, toggleSortByZone } = props;

  const zoneGuardsOccupancy = useSelector(zoneGuardsOccupancySelector);
  const zoneGuardsMustering = useSelector(zoneGuardsMusteringSelector);

  const zoneGuardMustering = zoneGuardsMustering?.[processorId];
  const accounted = zoneGuardMustering?.mustered?.reduce((sum, z) => sum + z.occupancies.length, 0) ?? 0;
  const outstanding = zoneGuardMustering?.outstanding?.reduce((sum, z) => sum + z.occupancies.length, 0) ?? 0;
  const total = accounted + outstanding;

  const occupancies = zoneGuardsOccupancy?.[processorId];

  return (
    <div className={styles.wrapper}>
      {isEmergencyMode ? (
        <>
          <MusteringPanel total={total} accounted={accounted} outstanding={outstanding} />
          <OccupancyHeader isSortedByZone={isSortedByZone} toggleSortByZone={toggleSortByZone} />
          {isSortedByZone ? (
            <OccupanciesByZone isLoading={isLoading} occupancies={zoneGuardMustering?.outstanding} />
          ) : (
            <OccupanciesByDevice isLoading={isLoading} occupancies={zoneGuardMustering?.outstanding} />
          )}
        </>
      ) : (
        <OccupanciesByZone isLoading={isLoading} occupancies={occupancies} />
      )}
    </div>
  );
};
